import { Route, Routes } from 'react-router';
import { Shell } from '../layouts/Shell.jsx';
import { Applications } from '../pages/Applications.jsx';
import { Audit } from '../pages/Audit.jsx';
import { Channels } from '../pages/Channels.jsx';
import { Contracts } from '../pages/Contracts.jsx';
import { CorrelationDetail, Correlations } from '../pages/Correlations.jsx';
import { Dashboard } from '../pages/Dashboard.jsx';
import { DeadLetters } from '../pages/DeadLetters.jsx';
import { LiveTraffic } from '../pages/LiveTraffic.jsx';
import { MessageDetail, Messages } from '../pages/Messages.jsx';
import { Permissions } from '../pages/Permissions.jsx';
import { Providers } from '../pages/Providers.jsx';
import { ReleaseNotes } from '../pages/ReleaseNotes.jsx';
import { Settings } from '../pages/Settings.jsx';

/** The twelve areas of the console, each one a page and nothing more. */
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Dashboard />} />
        <Route path="live" element={<LiveTraffic />} />
        <Route path="applications" element={<Applications />} />
        <Route path="channels" element={<Channels />} />
        <Route path="messages" element={<Messages />} />
        <Route path="messages/:id" element={<MessageDetail />} />
        <Route path="correlations" element={<Correlations />} />
        <Route path="correlations/:correlationId" element={<CorrelationDetail />} />
        <Route path="dead-letters" element={<DeadLetters />} />
        <Route path="permissions" element={<Permissions />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="providers" element={<Providers />} />
        <Route path="audit" element={<Audit />} />
        <Route path="settings" element={<Settings />} />
        <Route path="release" element={<ReleaseNotes />} />
        <Route path="*" element={<p className="empty muted">Pagina non trovata.</p>} />
      </Route>
    </Routes>
  );
}
